import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { Currency } from '../../../../../../src/components/common/number';
import { Small } from '@dbk/ui-text';
import TableRow from '../../../../../../src/components/common/table-row';
import { SEPARATOR_STROKE } from '../../../../../../src/constants';
import { HorizontalDashes } from '../../../../../../src/components/common/dashes';
import SimpleDate from '../../../../../../src/components/common/date';
import styles from '../../../../../../src/screens/income-history/_product-content/product-content.styles';

class ProductContent extends PureComponent {

  render() {
    const { row, i18n: { messages } } = this.props;
    if (!this.props.row) {
      return (
        <View />
      );
    }
    return (
      <View>
        <HorizontalDashes stroke={SEPARATOR_STROKE} style={styles.seperator} />
        <View style={styles.collapseContent}>
          <TableRow>
            <TableRow.Column align="left" >
              <Small style={styles.label} >{messages['app.incomehistory.reference']}:</Small>
              <Small style={styles.label}>{messages['app.report.transactionHistory.valueDate']}:</Small>
              <Small style={[styles.label]}>{messages['app.incomehistory.AmtPosCCy']}:</Small>
            </TableRow.Column>
            <TableRow.Column align="right" >
              <Small>{row.ieRefNo}</Small>
              <Small>
                <SimpleDate value={row.ieValDate} />
              </Small>
              <Currency
                renderProps={{
                  size: 'small',
                  testID: 'Interest-amount-value'
                }}
                currency={row.iePosCcy}
                value={row.ieTrnAmtPosCcy} />
            </TableRow.Column>
          </TableRow>
        </View>
        <HorizontalDashes stroke={SEPARATOR_STROKE} style={styles.seperator} />
        <Small style={styles.label} > {row.ieDesc} </Small>
      </View>
    );
  }
}
export default createContainer({
  $queries: {
  },
})(ProductContent);
